import React from 'react'

function TenderTextGDR() {
  return (
    <embed src="\pdfs\EA2.1.2_gd-r_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextGDR